import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "title", "message", "button"]

  connect() {
    this.handleEscapeBound = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.handleEscapeBound)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscapeBound)
  }

  // Open modal with user data
  openModal(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const userName = button.dataset.userName
    const isAdmin = button.dataset.isAdmin === 'true'
    const togglePath = button.dataset.togglePath

    // Update modal content
    this.updateModalContent(userName, isAdmin)
    
    // Update form action
    const form = document.getElementById('adminConfirmationForm')
    if (form) {
      form.action = togglePath
    }

    // Show modal using the existing modal system
    const modal = document.getElementById('adminConfirmationModal')
    if (modal) {
      modal.classList.remove('hidden')
      modal.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }))
    }
  }

  // Update modal content based on action
  updateModalContent(userName, isAdmin) {
    const titleElement = document.getElementById('adminActionTitle')
    const messageElement = document.getElementById('adminConfirmationMessage')
    const buttonElement = document.getElementById('adminConfirmationButton')

    if (isAdmin) {
      // Demoting admin
      titleElement.textContent = 'Retirar Privilégios de Administrador'
      messageElement.innerHTML = `Tem certeza que deseja <strong>retirar os privilégios de administrador</strong> de <strong>${this.escapeHtml(userName)}</strong>?`
      buttonElement.textContent = 'Retirar Acesso Admin'
      buttonElement.className = buttonElement.className
        .replace('bg-amber-600', 'bg-red-600')
        .replace('hover:bg-amber-500', 'hover:bg-red-500')
        .replace('focus-visible:outline-amber-600', 'focus-visible:outline-red-600')
    } else {
      // Promoting to admin
      titleElement.textContent = 'Promover a Administrador'
      messageElement.innerHTML = `Tem certeza que deseja <strong>promover</strong> <strong>${this.escapeHtml(userName)}</strong> <strong>a administrador</strong>?`
      buttonElement.textContent = 'Promover a Admin'
      buttonElement.className = buttonElement.className
        .replace('bg-red-600', 'bg-amber-600')
        .replace('hover:bg-red-500', 'hover:bg-amber-500')
        .replace('focus-visible:outline-red-600', 'focus-visible:outline-amber-600')
    }
  }

  // Close modal
  closeModal(event) {
    event?.preventDefault()
    
    const modal = document.getElementById('adminConfirmationModal')
    if (modal) {
      modal.classList.add('hidden')
      modal.dispatchEvent(new CustomEvent('modal:closed', { bubbles: true }))
    }
  }

  // Handle escape key
  handleEscape(event) {
    if (event.key === "Escape") {
      const modal = document.getElementById('adminConfirmationModal')
      const isVisible = modal && !modal.classList.contains("hidden")
      
      if (isVisible) {
        this.closeModal()
      }
    }
  }

  // Handle outside click
  closeOnOutsideClick(event) {
    if (event.target === event.currentTarget) {
      event.preventDefault()
      this.closeModal()
    }
  }

  // Utility function to escape HTML
  escapeHtml(unsafe) {
    return unsafe
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
  }
} 
